export default __webpack_public_path__ + "static/Fellix-BlackItalic-1b6332bc300543fe5cd9a3edb8acfa06.otf";